var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002E81",
    d: "M23.072 44.235c12.215 0 22.118-9.902 22.118-22.118C45.19 9.902 35.287 0 23.072 0 10.857 0 .955 9.902.955 22.117c0 12.216 9.902 22.118 22.117 22.118Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.799 18.002h4.28v13.767H13.8V18.002Zm2.148-6.838a2.473 2.473 0 0 1 2.48 2.481 2.473 2.473 0 0 1-2.48 2.481 2.482 2.482 0 0 1-2.481-2.48 2.482 2.482 0 0 1 2.48-2.482ZM20.773 18.004h4.1v1.876h.06c.575-1.09 1.966-2.224 4.054-2.224 4.327 0 5.128 2.844 5.128 6.55v7.55h-4.28v-6.687c0-1.604-.031-3.646-2.225-3.646-2.193 0-2.571 1.74-2.571 3.54v6.808h-4.282V18.004h.015Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/LN.6226edfbca2b3a9b4f1aa7a9080593ab.svg";
export { ForwardRef as ReactComponent };